var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6747ED;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441,
    cy: 441.2,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88.000000, -52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st1",
    d: "M522.6,550.1c-65.2,0-117.5-52.3-117.5-117.5c0-65.2,52.3-117.5,117.5-117.5 s117.5,52.3,117.5,117.5S587.7,550.1,522.6,550.1 M522.6,256.3c97.3,0,176.2,78.9,176.2,176.2s-78.9,176.2-176.2,176.2 c-97.3,0-176.2-78.9-176.2-176.2S425.3,256.3,522.6,256.3z M690.5,618c11.9,11.9,11.9,30.3,0,41.3L573,776.8 c-11.9,11.9-30.3,11.9-41.3,0c-11.9-11.9-11.9-30.3,0-41.3L649.2,618C660.2,606.1,679.5,606.1,690.5,618z M758.5,285.7 c0,16.5-12.9,29.4-29.4,29.4c-16.5,0-29.4-12.9-29.4-29.4c0-16.5,12.9-29.4,29.4-29.4C744.7,256.3,758.5,269.2,758.5,285.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrtIcon);
export default __webpack_public_path__ + "static/media/grt_icon.09b4ab03d4ae5bb4c7d0b81b52730704.svg";
export { ForwardRef as ReactComponent };